import { createBrowserRouter } from 'react-router'

import {
  AuthenticatedLayout,
  requireAuth,
} from '@/routes/layouts/AuthenticatedLayout'
import { RootLayout } from '@/routes/layouts/RootLayout'
import { privateRoutes } from './private.routes'
import { publicRoutes } from './public.routes'

export const router = createBrowserRouter([
  {
    element: <RootLayout />,
    children: [
      ...publicRoutes,
      {
        element: <AuthenticatedLayout />,
        loader: requireAuth,
        children: privateRoutes,
      },
    ],
  },
])
